'use client'
import Link from 'next/link';
//import blukai, removido

export default function LinkBluKai({ children, llave, valor, ...rest }) {
  return (
    <Link
      onClick={() => {
        //blukai function, removida
      }}
      {...rest}
    >
      {children}
    </Link>
  );
}
